import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'accessibility-dashboard-distribution',
    standalone: false,
    template: `
        <accessibility-dashboard-distribution-progress-bar class="block px-2"
                                                           [checkA]="checkA"
                                                           [checkAa]="checkAA"
                                                           [total]="total"
                                                           [checkAaa]="checkAAA"
                                                           [fixed]="fixed">
        </accessibility-dashboard-distribution-progress-bar>
        <div class="pt-1 d-flex">
            <div class="mr-auto">{{'[[fixed]] Checks done' | translate:'':{fixed} }}</div>
            <div>{{'[[errors]] Checks to fix' | translate:'':{errors: total - fixed} }}</div>
        </div>

    `,
})
export class AccessibilityDashboardDistributionComponent implements OnInit {
    @Input() summary: any = {};
    @Input() total = 0;
    checkA = 0;
    checkAA = 0;
    checkAAA = 0;
    fixed = 0;

    ngOnInit () {
        this.checkA = 0;
        this.checkAA = 0;
        this.checkAAA = 0;
        this.fixed = 0;
        this.getChecks();
    }

    getChecks () {
        this.checkA = this.summary.checks_with_issues_by_abbr.A;
        this.checkAA = this.summary.checks_with_issues_by_abbr.AA;
        this.checkAAA = this.summary.checks_with_issues_by_abbr.AAA;
        const issueAbbrs = Object.keys(this.summary.checks_with_issues_by_abbr);
        this.fixed =
            this.total -
            issueAbbrs.reduce((a, b) => {
                return a + this.summary.checks_with_issues_by_abbr[b];
            }, 0); // Now it's the API team's problem if this count fails, muhahaha!
    }

    calcWidth (input) {
        return (parseInt(input) / this.total) * 100 + '%';
    }
}
